var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._b({attrs:{"color":_vm.color,"elevation":"0","fab":""}},"v-btn",_vm._d({},[_vm.buttonSizeClass,true])),[_c('lynus-icon',{attrs:{"name":_vm.icon,"size":_vm.iconSize,"color":"white"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }